import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import SignatureCanvas from 'react-signature-canvas';
import { contienePalabrasOfensivas } from '../utils/validaciones';
import './Dashboard.css';

const Dashboard = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filtros, setFiltros] = useState({
    categoria: '',
    estado: ''
  });

  const [equipos, setEquipos] = useState([]);
  const [profanityList, setProfanityList] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedEquipo, setSelectedEquipo] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [isHistorialLoading, setIsHistorialLoading] = useState(false);
  const [nuevoCustodio, setNuevoCustodio] = useState('');
  const [notaTransferencia, setNotaTransferencia] = useState('');
  const [isTransferring] = useState(false);
  const [referenciaActa, setReferenciaActa] = useState('Gestión Interna - UDT');
  const [autoActaType, setAutoActaType] = useState('recepcion');
  const [fechaDevolucion, setFechaDevolucion] = useState('');

  const [showPrintPrepModal, setShowPrintPrepModal] = useState(false);
  const [prepData, setPrepData] = useState({
    estadoGeneral: 'CONFORME',
    observaciones: '',
    signatureCustodio: null,
    signatureEncargado: null,
    actaType: 'recepcion',
    equipoToPrint: null,
    pendingAction: null,
    pendingPayload: null
  });
  const sigPadCustodio = React.useRef(null);
  const sigPadEncargado = React.useRef(null);

  const [activeTab, setActiveTab] = useState('general');
  const [regTab, setRegTab] = useState('tecnica');
  const [apiError, setApiError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [formData, setFormData] = useState({
    codigo: '', modelo: '', categoria: 'PC', estado: 'Operativo', custodio: '', detalle: ''
  });
  const [funcionariosList, setFuncionariosList] = useState([]);
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3001` : `https://${window.location.hostname}`;


  const fetchEquipos = async () => {
    setIsLoading(true);
    try {
      const resp = await fetch(`${apiBase}/api/equipos`);
      if (resp.ok) {
        const data = await resp.json();
        const mappedData = data.map(eq => ({ ...eq, custodio: eq.custodio_id }));
        setEquipos(mappedData);
      }
    } catch (err) {
      console.error('Error de red consultando Backend:', err);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchFuncionariosData = async () => {
    try {
      const resp = await fetch(`${apiBase}/api/funcionarios`);
      if (resp.ok) setFuncionariosList(await resp.json());
    } catch (err) { console.error(err); }
  };

  const fetchProfanityList = async () => {
    try {
      const resp = await fetch(`${apiBase}/api/config/profanity`);
      if (resp.ok) {
        const data = await resp.json();
        setProfanityList(data.words);
      }
    } catch (err) { console.error('Error fetching profanity list:', err); }
  };

  const fetchNetworkInfo = async () => {
    try {
      const resp = await fetch(`${apiBase}/api/config/network-info`);
      if (resp.ok) {
        const data = await resp.json();
        console.log('Local IP for QR:', data.localIp);
      }
    } catch (err) { console.error('Error fetching network info:', err); }
  };

  useEffect(() => {
    fetchEquipos();
    fetchFuncionariosData();
    fetchProfanityList();
    fetchNetworkInfo();
  }, []);

  const handleOpenModal = (equipo = null) => {
    setApiError(null);
    setRegTab('tecnica');
    setAutoActaType('recepcion');


    if (equipo) {
      setFormData({
        codigo: equipo.codigo,
        modelo: equipo.modelo,
        categoria: equipo.categoria || 'PC',
        estado: equipo.estado || 'Operativo',
        custodio: equipo.custodio_id || '',
        detalle: equipo.detalle || ''
      });
    } else {
      setFormData({
        codigo: '',
        modelo: '',
        categoria: 'PC',
        estado: 'Operativo',
        custodio: '',
        detalle: ''
      });
    }

    setIsModalOpen(true);


    fetchFuncionariosData();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setRegTab('tecnica');
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleNextStep = () => {
    setApiError(null);
    const offensiveWord = contienePalabrasOfensivas(`${formData.codigo} ${formData.modelo} ${formData.detalle}`, profanityList);
    if (offensiveWord) {
      setApiError(`No puedes avanzar: Se ha detectado lenguaje inapropiado ("${offensiveWord}") en los detalles técnicos.`);
      return;
    }
    setRegTab('asignacion');
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setApiError('');


    const offensiveWord = contienePalabrasOfensivas(`${formData.codigo} ${formData.modelo} ${formData.detalle}`, profanityList);
    if (offensiveWord) {
      setApiError(`Se ha detectado lenguaje inapropiado ("${offensiveWord}"). Por favor, revisa el contenido.`);
      return;
    }

    const usuario = JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Sistema';
    try {
      const resp = await fetch(`${apiBase}/api/equipos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, usuario })
      });
      if (!resp.ok) {
        const errData = await resp.json();
        throw new Error(errData.error || 'Error al crear equipo');
      }

      const newEntity = await resp.json();
      setIsModalOpen(false);


      await fetchFuncionariosData();

      if (formData.custodio) {
        const func = funcionariosList.find(f => f.id === formData.custodio);
        const tempEquipo = {
          ...formData,
          id: newEntity.id || 'N/A',
          custodio_nombre: func?.nombre,
          custodio_rut: func?.rut,
          custodio_cargo: func?.cargo
        };

        setTimeout(() => {
          setSelectedEquipo(tempEquipo);
          setPrepData({
            estadoGeneral: 'CONFORME',
            observaciones: 'INGRESO INICIAL A BODEGA Y REGISTRO EN INVENTARIO.',
            signatureCustodio: null,
            signatureEncargado: null,
            actaType: autoActaType,
            equipoToPrint: tempEquipo,
            pendingAction: 'create',
            pendingPayload: { ...formData, id: newEntity.id }
          });
          setShowPrintPrepModal(true);
        }, 800);
      } else {
        const tempEquipo = {
          ...formData,
          id: newEntity.id || 'N/A',
          custodio_nombre: 'BODEGA MUNICIPAL',
          custodio_rut: 'Varios',
          custodio_cargo: 'Stock'
        };

        setTimeout(() => {
          setSelectedEquipo(tempEquipo);
          setPrepData({
            estadoGeneral: 'CONFORME',
            observaciones: 'ALTA DE BIEN MUNICIPAL - INGRESO A BODEGA.',
            signatureCustodio: null,
            signatureEncargado: null,
            actaType: 'ingreso_bodega',
            equipoToPrint: tempEquipo,
            pendingAction: 'create',
            pendingPayload: { ...formData, id: newEntity.id }
          });
          setShowPrintPrepModal(true);
        }, 800);
      }

      fetchEquipos();
    } catch (err) {
      setApiError(err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar este equipo permanentemente? Se borrará su historial y actas asociadas.')) return;
    try {
      const resp = await fetch(`${apiBase}/api/equipos/${id}`, { method: 'DELETE' });
      if (resp.ok) {
        fetchEquipos();
      } else {
        alert('Error al borrar el registro del servidor.');
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [actasArchivadas, setActasArchivadas] = useState([]);

  const handleOpenDetails = async (equipo) => {
    setSelectedEquipo(equipo);
    setDetailModalOpen(true);
    setActiveTab('general');
    setNuevoCustodio(equipo.custodio_id || '');
    setNotaTransferencia('');
    setAutoActaType('traslado');
    setIsHistorialLoading(true);
    setHistorial([]);
    setActasArchivadas([]);

    try {
      const [histResp, actasResp] = await Promise.all([
        fetch(`${apiBase}/api/equipos/${equipo.id}/historial`),
        fetch(`${apiBase}/api/equipos/${equipo.id}/actas`)
      ]);

      if (histResp.ok) setHistorial(await histResp.json());
      if (actasResp.ok) setActasArchivadas(await actasResp.json());
    } catch (err) {
      console.error('Error al obtener datos del equipo', err);
    } finally {
      setIsHistorialLoading(false);
    }
  };

  const handleChangeStatus = async (id, nuevoEstado) => {
    if (nuevoEstado === selectedEquipo.estado) return;

    if (nuevoEstado === 'Mantenimiento') {
      setPrepData({
        estadoGeneral: 'INCONFORME',
        observaciones: 'EQUIPO ENVIADO A MANTENIMIENTO TÉCNICO.',
        signatureCustodio: null,
        signatureEncargado: null,
        actaType: 'mantenimiento',
        equipoToPrint: selectedEquipo,
        pendingAction: 'status_mantenimiento',
        pendingPayload: { nuevoEstado: 'Mantenimiento' }
      });
      setShowPrintPrepModal(true);
      return;
    }

    setIsHistorialLoading(true);
    try {
      const resp = await fetch(`${apiBase}/api/equipos/${id}/estado`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nuevoEstado, usuario: JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Sistema' })
      });
      if (resp.ok) {
        setSelectedEquipo({ ...selectedEquipo, estado: nuevoEstado });
        fetchEquipos();
        const histResp = await fetch(`${apiBase}/api/equipos/${id}/historial`);
        if (histResp.ok) {
          const logData = await histResp.json();
          setHistorial(logData);
        }
      } else {
        const errObj = await resp.json();
        alert('Error devuelto por la Base de Datos: ' + errObj.error);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsHistorialLoading(false);
    }
  };

  const handleTransferCustodio = async () => {
    if (nuevoCustodio === (selectedEquipo.custodio_id || '')) return alert('Selecciona un custodio diferente al actual.');
    const selectedFunc = funcionariosList.find(f => f.id === nuevoCustodio);
    if (!window.confirm(`¿Confirmar transferencia a: ${selectedFunc?.nombre || 'Sin asignar'}?`)) return;
    const usuario = JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Sistema';
    setPrepData({
      estadoGeneral: 'CONFORME',
      observaciones: notaTransferencia || (nuevoCustodio ? '' : 'DEVOLUCIÓN DE ACTIVO A BODEGA MUNICIPAL.'),
      signatureCustodio: null,
      signatureEncargado: null,
      actaType: nuevoCustodio ? autoActaType : 'devolucion',
      equipoToPrint: selectedEquipo,
      pendingAction: 'transfer',
      pendingPayload: { nuevoCustodio: nuevoCustodio || null, nota: notaTransferencia, usuario }
    });
    setShowPrintPrepModal(true);
  };

  const downloadQR = () => {
    const canvas = document.getElementById("qr-gen");
    if (!canvas) return;
    const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `ETIQUETA_QR_${selectedEquipo?.codigo || 'EQUIPO'}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handlePrintQR = () => {
    const canvas = document.getElementById("qr-gen");
    if (!canvas) return;
    const dataUrl = canvas.toDataURL("image/png");
    const windowContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Imprimir QR - ${selectedEquipo?.codigo}</title>
          <style>
            body { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; margin: 0; font-family: sans-serif; text-align: center; }
            .label-container { border: 1px dashed #ccc; padding: 20px; border-radius: 10px; display: inline-block; }
            img { width: 128px; height: 128px; margin-bottom: 10px; display: block; margin-left: auto; margin-right: auto; }
            h2 { margin: 0; color: #333; font-size: 16px; font-weight: bold; }
            p { margin: 2px 0; color: #666; font-size: 11px; text-transform: uppercase; }
            @media print {
              .no-print { display: none; }
              body { height: auto; padding-top: 20px; }
              .label-container { border: none; }
            }
          </style>
        </head>
        <body>
          <div class="label-container">
            <img src="${dataUrl}" />
            <h2>${selectedEquipo?.codigo}</h2>
            <p>${selectedEquipo?.modelo}</p>
            <p style="font-size: 9px;">${selectedEquipo?.categoria}</p>
          </div>
          <div class="no-print">
            <button onclick="window.print()" style="padding: 10px 20px; background: #0d6efd; color: white; border: none; border-radius: 5px; cursor: pointer;">Imprimir Ahora</button>
            <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 5px; cursor: pointer; margin-left: 10px;">Cerrar</button>
          </div>
          <script>
            window.onload = () => {
              // Comentamos el print automático para que el usuario vea la vista previa primero
              // window.print();
            };
          </script>
        </body>
      </html>
    `;
    const printWindow = window.open('', '_blank', 'width=600,height=600');
    printWindow.document.open();
    printWindow.document.write(windowContent);
    printWindow.document.close();
  };

  const handleGenerateActa = async (type, overrideEquipo = null, extraData = null, existingCorrelativo = null) => {
    const currentEquipo = overrideEquipo || selectedEquipo;
    if (!currentEquipo) return;

    let correlativo = existingCorrelativo ? String(existingCorrelativo).padStart(4, '0') : "___";

    if (!existingCorrelativo) {
      try {
        const resp = await fetch(`${apiBase}/api/actas`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            equipo_id: currentEquipo.id,
            tipo: type,
            referencia: referenciaActa,
            data_json: extraData ? JSON.stringify(extraData) : null,
            fecha_devolucion: type === 'prestamo' ? fechaDevolucion : null,
            usuario: JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Sistema',
            observaciones: extraData?.observaciones || '',
            estadoGeneral: extraData?.estadoGeneral || '',
            custodio_id: extraData?.selectedFuncionarioId || null
          })
        });

        if (resp.ok) {
          const data = await resp.json();
          correlativo = String(data.correlativo).padStart(4, '0');
        } else {
          const errData = await resp.json();
          alert('Aviso: Correlativo de Acta generado pero el archivo digital puede haber fallado: ' + errData.error);
        }
      } catch (error) {
        console.error('[DATABASE ERROR]: Falló registro de acta en DB', error);
        alert('Error de conexión al intentar archivar el documento.');
      }
    }
    const funcionarioData = funcionariosList.find(f =>
      f.id === (currentEquipo.custodio_id || currentEquipo.custodio) ||
      (f.nombre || "").trim().toLowerCase() === (currentEquipo.custodio_nombre || "").trim().toLowerCase()
    );

    const docNombre = (funcionarioData && funcionarioData.nombre) ? funcionarioData.nombre : (currentEquipo.custodio_nombre || currentEquipo.custodio || '__________________________');
    const docRut = (funcionarioData && funcionarioData.rut) ? funcionarioData.rut : (currentEquipo.custodio_rut || '__________________________');
    const docCargo = (funcionarioData && funcionarioData.cargo) ? funcionarioData.cargo : (currentEquipo.custodio_cargo || '__________________________');

    const dateStr = new Date().toLocaleDateString('es-CL', { day: '2-digit', month: 'long', year: 'numeric' });
    const logoUrl = '/logo_pitrufquen.png';

    let mainTitle = "";
    let objectiveText = "";
    let declarationExtra = "";
    let typeCode = "";

    if (type === 'recepcion') {
      mainTitle = "Acta de Recepción Conforme de Activo";
      typeCode = "AC - RecepciónConformeActivo";
      objectiveText = "certificar la recepción física y la conformidad de los activos detallados, los cuales han sido inspeccionados por la parte que recibe y se encuentran en buen estado, completos y cumplen con las especificaciones técnicas o requisitos de la Orden de Compra/Contrato de referencia.";
    } else if (type === 'traslado') {
      mainTitle = "Acta de Traslado de Activo";
      typeCode = "AC - TrasladoActivo";
      objectiveText = "documentar el movimiento físico y cambio de ubicación de los activos detallados entre distintas dependencias municipales, asegurando su trazabilidad y correcto estado.";
    } else if (type === 'prestamo') {
      mainTitle = "Acta de Préstamo de Activo";
      typeCode = "AC - PréstamoActivo";
      objectiveText = "certificar la recepción física de los activos en préstamo, estos deberán ser inspeccionados por la parte que recibe, cerciorando que se encuentran en buen estado, completos y cumplen con las especificaciones técnicas o requisitos solicitados.";
      declarationExtra = " de Préstamo de Activo";
    } else if (type === 'mantenimiento') {
      mainTitle = "Acta de Entrega a Mantenimiento Técnico";
      typeCode = "AC - MantenimientoTécnico";
      objectiveText = "documentar la salida física del activo desde su ubicación habitual hacia el servicio técnico o área de mantenimiento, con el fin de realizar reparaciones, revisiones preventivas o correctivas, asegurando el control del bien durante su permanencia fuera de uso operativo.";
    } else if (type === 'devolucion') {
      mainTitle = "Acta de Reintegro de Activo a Bodega";
      typeCode = "AC - ReintegroBodega";
      objectiveText = "formalizar la devolución física del activo a la bodega municipal por parte del funcionario custodio, certificando el término de su responsabilidad directa sobre el bien y su reincorporación al stock general.";
    } else if (type === 'ingreso_bodega') {
      mainTitle = "Acta de Ingreso y Alta en Inventario Municipal";
      typeCode = "AC - IngresoInventario";
      objectiveText = "certificar la incorporación física de un nuevo activo al patrimonio municipal y su ingreso inicial a la bodega de la Unidad de Desarrollo Tecnológico, validando sus características técnicas y estado de recepción.";
    }

    const headerHtml = (pageNum) => `
      <table class="header-table">
        <tr>
          <td rowspan="2" class="logo-cell"><img src="${logoUrl}" alt="Logo"></td>
          <td class="title-cell" colspan="3">Unidad de Desarrollo Tecnológico y Transformación Digital</td>
        </tr>
        <tr>
          <td style="width: 30%;">Versión: 1.0.0</td>
          <td style="width: 40%;">Fecha: ${new Date().toLocaleDateString('es-CL')}</td>
          <td style="width: 30%;">Página ${pageNum} de 5</td>
        </tr>
      </table>
    `;

    const windowContent = `
      <!DOCTYPE html>
      <html lang="es">
      <head>
        <meta charset="UTF-8">
        <title>${mainTitle} - ${currentEquipo.codigo}</title>
        <style>
          @page { size: A4; margin: 0; }
          body { font-family: 'Arial', sans-serif; font-size: 11pt; line-height: 1.5; color: #000; margin: 0; padding: 0; background-color: #f0f0f0; }

          .page {
            width: 210mm;
            min-height: 297mm;
            padding: 20mm;
            margin: 10mm auto;
            background: white;
            box-shadow: 0 0 10px rgba(0,0,0,0.1);
            box-sizing: border-box;
            page-break-after: always;
            position: relative;
          }

          .header-table { width: 100%; border-collapse: collapse; margin-bottom: 30px; }
          .header-table td { border: 1.5px solid #000; padding: 12px; text-align: center; vertical-align: middle; font-weight: bold; }
          .logo-cell { width: 100px; padding: 5px !important; }
          .logo-cell img { height: 75px; object-fit: contain; }
          .title-cell { font-size: 13pt; text-transform: none; }

          h1 { text-align: center; font-size: 24pt; margin: 60px 0; font-weight: bold; }
          .big-logo-container { text-align: center; margin: 40px 0; }
          .big-logo { width: 350px; }

          .doc-info-box { border: 1.5px solid #000; padding: 20px; margin: 40px 0; line-height: 1.6; }
          .history-table { width: 100%; border-collapse: collapse; margin-top: 30px; text-align: center; }
          .history-table td { border: 1.5px solid #000; padding: 10px; }
          .bg-grey { background-color: #f2f2f2; font-weight: bold; }

          .section-title { font-weight: bold; font-size: 12pt; margin-top: 35px; margin-bottom: 15px; display: block; text-decoration: none; }
          .objective-text { text-align: justify; padding-left: 5px; }

          .data-table { width: 100%; border-collapse: collapse; margin-top: 25px; }
          .data-table th, .data-table td { border: 1.5px solid #000; padding: 12px; text-align: left; }
          .data-table th { background-color: #f2f2f2; width: 30%; }

          .assets-table { width: 100%; border-collapse: collapse; margin-top: 25px; }
          .assets-table th, .assets-table td { border: 1.5px solid #000; padding: 10px; text-align: center; height: 32px; }
          .assets-table th { background-color: #f2f2f2; font-weight: bold; font-size: 10pt; }

          .conformity { margin-top: 50px; text-align: justify; line-height: 1.8; }
          .signature-section { margin-top: 120px; display: flex; justify-content: space-between; padding: 0 20px; }
          .signature-box { text-align: center; width: 280px; }
          .signature-line { border-top: 1.5px solid #000; margin-bottom: 8px; }
          .signature-name { font-weight: bold; font-size: 11pt; text-transform: uppercase; }
          .signature-title { font-size: 10pt; color: #333; }

          .status-table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          .status-table td { border: 1.5px solid #000; padding: 12px; vertical-align: top; }
          .status-label { font-weight: bold; background-color: #f2f2f2; width: 35%; }
          .checkbox-group { display: flex; flex-direction: column; gap: 10px; }
          .checkbox-item { display: flex; align-items: center; gap: 10px; font-size: 10pt; }
          .box { width: 22px; height: 22px; border: 1.5px solid #000; flex-shrink: 0; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 16px; background: white; }

          @media print {
            body { background: none; }
            .page { margin: 0; box-shadow: none; border: none; }
            .no-print { display: none; }
          }

          .print-nav { position: fixed; bottom: 30px; right: 30px; display: flex; gap: 10px; z-index: 9999; }
          .btn-nav { padding: 12px 24px; border-radius: 50px; border: none; font-weight: bold; cursor: pointer; box-shadow: 0 4px 15px rgba(0,0,0,0.2); }
          .btn-print { background: #20c997; color: white; }
          .btn-close { background: #6c757d; color: white; }
        </style>
      </head>
      <body>
        <div class="print-nav no-print">
          <button class="btn-nav btn-close" onclick="window.close()">Cerrar Vista</button>
          <button class="btn-nav btn-print" onclick="window.print()">Imprimir Acta Oficial</button>
        </div>

        <!-- PÁGINA 1 -->
        <div class="page">
          ${headerHtml(1)}
          <h1>${mainTitle}</h1>
          <div class="big-logo-container">
            <img src="${logoUrl}" class="big-logo" alt="Escudo Municiapl">
          </div>
          <div class="doc-info-box">
            <strong>${typeCode}:</strong><br>
            Documento que evidencia el acto de entrega de un activo y la recepción conforme por parte del funcionario custodio municipal.
          </div>
          <table class="history-table">
            <tr class="bg-grey">
              <td>Versión</td><td>Aprobado por</td><td>Fecha de actualización</td>
            </tr>
            <tr>
              <td>1.0.0</td><td style="color: #dc3545;">REVISIÓN PENDIENTE</td><td>24 de marzo de 2026</td>
            </tr>
          </table>
        </div>

        <!-- PÁGINA 2 -->
        <div class="page">
          ${headerHtml(2)}
          <div class="section-title">OBJETIVO</div>
          <p class="objective-text">El presente documento tiene como objetivo ${objectiveText}</p>
        </div>

        <!-- PÁGINA 3 -->
        <div class="page">
          ${headerHtml(3)}
          <h2 style="text-align: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 40px;">${mainTitle}</h2>
          <div style="margin-bottom: 50px; text-align: right; line-height: 2.2; font-weight: bold;">
            Nro: ${correlativo}<br>
            Fecha de Recepción: ${dateStr}<br>
            ${type === 'prestamo' && fechaDevolucion ? `FECHA DE DEVOLUCIÓN: ${new Date(fechaDevolucion + 'T12:00:00').toLocaleDateString('es-CL')}<br>` : ''}
            Ref: ${referenciaActa}
          </div>

          <table class="data-table">
            <tr class="bg-grey"><td colspan="2">${type === 'devolucion' ? 'RECEPCIÓN (BODEGA MUNICIPAL):' : 'ENTREGA:'}</td></tr>
            <tr><td>Municipalidad de Pitrufquén</td><td>Yessenia Castillo - Encargada de Inventario</td></tr>
            <tr class="bg-grey"><td colspan="2">${type === 'devolucion' ? 'FUNCIONARIO QUE RESTITUYE EL BIEN:' : 'RECIBE:'}</td></tr>
            <tr><td><strong>Nombre</strong></td><td>${docNombre}</td></tr>
            <tr><td><strong>Rut</strong></td><td>${docRut}</td></tr>
            <tr><td><strong>Cargo</strong></td><td>${docCargo}</td></tr>
          </table>
        </div>

        <!-- PÁGINA 4 -->
        <div class="page">
          ${headerHtml(4)}
          <div class="section-title">ACTIVOS</div>
          <table class="assets-table">
            <thead>
              <tr class="bg-grey">
                <th style="width: 20%;">N° Inventario</th>
                <th style="width: 35%;">ACTIVO</th>
                <th style="width: 10%;">CANT</th>
                <th style="width: 15%;">ESTADO</th>
                <th style="width: 20%;">OBSERVACIONES</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>${currentEquipo.codigo}</td>
                <td style="text-align: left;">${currentEquipo.categoria} / ${currentEquipo.modelo}</td>
                <td>1</td>
                <td>${currentEquipo.estado}</td>
                <td>${currentEquipo.detalle || ''}</td>
              </tr>
              ${Array(14).fill('<tr><td></td><td></td><td></td><td></td><td></td></tr>').join('')}
            </tbody>
          </table>
        </div>

        <!-- PÁGINA 5 -->
        <div class="page">
          ${headerHtml(5)}
          <table class="status-table">
            <tr>
              <td class="status-label">ESTADO GENERAL</td>
              <td>
                <div class="checkbox-group">
                  <div class="checkbox-item"><div class="box">${extraData?.estadoGeneral === 'CONFORME' ? 'X' : ''}</div> CONFORME</div>
                  <div class="checkbox-item"><div class="box">${extraData?.estadoGeneral === 'INCONFORME' ? 'X' : ''}</div> INCONFORME</div>
                  <div class="checkbox-item"><div class="box">${extraData?.estadoGeneral === 'CONFORME CON OBSERVACIONES' ? 'X' : ''}</div> CONFORME CON OBSERVACIONES</div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="status-label" style="height: 120px;">OBSERVACIONES ADICIONALES</td>
              <td>${extraData?.observaciones || ''}</td>
            </tr>
          </table>

          <div class="conformity">
            <strong>DECLARACIÓN DE CONFORMIDAD:</strong> La parte que RECIBE, declara que:<br>
            1. Ha inspeccionado físicamente los activos detallados y verifica que corresponden a la cantidad y tipo solicitados.<br>
            2. El estado de los activos es CONFORME (salvo las observaciones específicas indicadas en la tabla anterior).<br>
            3. A partir de la fecha de la presente Acta, los activos pasan a ser responsabilidad de la Unidad/Departamento y/o funcionario que recibe para su custodia, uso e inventario. En constancia de lo anterior, se firma la presente Acta de Recepción Conforme${declarationExtra}.
          </div>

          <div class="signature-section">
            <div class="signature-box" style="position: relative; padding-top: 50px;">
              ${extraData?.signatureEncargado ? `<img src="${extraData.signatureEncargado}" style="position: absolute; bottom: 45px; left: 50%; transform: translateX(-50%); height: 85px; mix-blend-mode: multiply;">` : ''}
              <div class="signature-line" style="margin-top: 40px;"></div>
              <div class="signature-name">YESSENIA CASTILLO</div>
              <div class="signature-title">Encargada de Inventario</div>
            </div>
            ${type !== 'ingreso_bodega' ? `
              <div class="signature-box" style="position: relative; padding-top: 50px;">
                ${extraData?.signatureCustodio ? `<img src="${extraData.signatureCustodio}" style="position: absolute; bottom: 45px; left: 50%; transform: translateX(-50%); height: 85px; mix-blend-mode: multiply;">` : ''}
                <div class="signature-line" style="margin-top: 40px;"></div>
                <div class="signature-name">${docNombre.toUpperCase()}</div>
                <div class="signature-title">${funcionarioData ? funcionarioData.cargo : 'Funcionario Responsable'}</div>
              </div>
            ` : `
              <div class="signature-box" style="position: relative; padding-top: 50px;">
                <div style="margin-top: 40px; color: #666; font-style: italic; font-size: 9pt;">REGISTRO INICIAL - SOLO FIRMA ENCARGADO</div>
              </div>
            `}
          </div>
        </div>
      </body>
      </html>
    `;
    const printWindow = window.open('', '_blank', 'width=1000,height=900');
    printWindow.document.open();
    printWindow.document.write(windowContent);
    printWindow.document.close();
  };

  const filteredEquipos = equipos.filter(eq => {
    const term = searchTerm.toLowerCase();
    const matchesSearch = (
      (eq.codigo && eq.codigo.toLowerCase().includes(term)) ||
      (eq.modelo && eq.modelo.toLowerCase().includes(term)) ||
      (eq.categoria && eq.categoria.toLowerCase().includes(term)) ||
      (eq.estado && eq.estado.toLowerCase().includes(term)) ||
      (eq.detalle && eq.detalle.toLowerCase().includes(term))
    );
    const matchesCat = !filtros.categoria || eq.categoria === filtros.categoria;
    const matchesEstado = !filtros.estado || eq.estado === filtros.estado;

    return matchesSearch && matchesCat && matchesEstado;
  });

  return (
    <div className="dashboard-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>Gestor de Equipos</h2>
        </div>
        <nav className="sidebar-nav">
          <Link to="/dashboard" className="nav-item active">Equipos</Link>
          <Link to="/funcionarios" className="nav-item">Funcionarios</Link>
          {(JSON.parse(localStorage.getItem('user') || '{}').rol === 'admin' ||
            JSON.parse(localStorage.getItem('user') || '{}').rol === 'superadmin') && (
              <>
                <Link to="/supervisor" className="nav-item">Panel de Análisis</Link>
                <Link to="/usuarios" className="nav-item">Usuarios (Admin)</Link>
              </>
            )}
        </nav>
      </aside>

      <main className="main-content">
        <header className="view-page-header">
          <div className="view-title-block">
            <h2>Gestión de Inventario Municipal</h2>
            <p>Control general, altas y bajas del inventario de activos.</p>
          </div>
          <Link to="/perfil" className="user-profile" style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', height: 'fit-content' }}>
            <span>{JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Mi Perfil'}</span>
            <div className="avatar" style={{ background: '#0ea5e9' }}>{JSON.parse(localStorage.getItem('user') || '{}').nombre?.charAt(0).toUpperCase() || 'P'}</div>
          </Link>
        </header>


        <section className="premium-table-container" style={{ padding: '2rem', background: 'white' }}>
          <div className="datatable-header" style={{ marginBottom: '2rem' }}>
            <h2 style={{ margin: 0, fontSize: '1.4rem', color: '#0f172a' }}>Inventario Activo</h2>
            <div className="header-actions">
              <div className="search-bar">
                <input
                  type="text"
                  placeholder="Buscar equipo..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              <select
                className="filter-select premium-field"
                value={filtros.categoria}
                onChange={(e) => setFiltros({ ...filtros, categoria: e.target.value })}
                style={{ padding: '0.8rem 1.2rem', borderRadius: '12px', border: '2px solid #f1f5f9', fontSize: '14px', background: '#f8fafc' }}
              >
                <option value="">Todas las Categorías</option>
                <option value="PC">PC (Escritorio)</option>
                <option value="Notebook">Notebook</option>
                <option value="Impresora">Impresora</option>
                <option value="Hardware">Hardware / Red</option>
                <option value="Mobiliario">Mobiliario</option>
              </select>

              <select
                className="filter-select premium-field"
                value={filtros.estado}
                onChange={(e) => setFiltros({ ...filtros, estado: e.target.value })}
                style={{ padding: '0.8rem 1.2rem', borderRadius: '12px', border: '2px solid #f1f5f9', fontSize: '14px', background: '#f8fafc' }}
              >
                <option value="">Todos los Estados</option>
                <option value="Operativo">Operativo</option>
                <option value="Mantenimiento">Mantenimiento</option>
                <option value="Baja">Baja</option>
              </select>
              <button className="premium-btn primary" onClick={handleOpenModal}>
                <i className="fa-solid fa-plus"></i> Nuevo Equipo
              </button>
            </div>
          </div>

          <div className="table-responsive">
            <table className="premium-table">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Modelo</th>
                  <th>Categoría</th>
                  <th>Estado</th>
                  <th className="text-right">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr><td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>Cargando inventario...</td></tr>
                ) : filteredEquipos.length > 0 ? (
                  filteredEquipos.map(eq => (
                    <tr key={eq.id}>
                      <td><strong>{eq.codigo}</strong></td>
                      <td>{eq.modelo}</td>
                      <td><span className="badge category-badge">{eq.categoria || 'N/A'}</span></td>
                      <td>
                        <span className={`premium-badge ${(eq.estado === 'Operativo' ? 'success' : eq.estado === 'Mantenimiento' ? 'warning' : 'danger')}`}>
                          {eq.estado}
                        </span>
                      </td>
                      <td className="text-right">
                        <button className="icon-action-btn" onClick={() => handleOpenDetails(eq)} title="Detalles">
                          <i className="fa-solid fa-list-check"></i>
                        </button>
                        <button
                          className="icon-action-btn delete"
                          onClick={() => handleDelete(eq.id)} title="Eliminar"
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="no-results">El inventario está vacío. ¡Registra el primer equipo!</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </main>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content premium-modal">
            <div className="modal-header">
              <h3>Registrar Nuevo Equipo</h3>
              <button className="close-modal-btn" onClick={handleCloseModal}>&times;</button>
            </div>

            <div className="modal-tabs">
              <button type="button" className={`tab-btn ${regTab === 'tecnica' ? 'active' : ''}`} onClick={() => setRegTab('tecnica')}>1. Datos Técnicos</button>
              <button
                type="button"
                className={`tab-btn ${regTab === 'asignacion' ? 'active' : ''}`}
                onClick={() => {
                  if (formData.codigo && formData.modelo) setRegTab('asignacion');
                  else alert('Debes completar el Código y Modelo antes de continuar.');
                }}
                disabled={!formData.codigo || !formData.modelo}
                style={{ opacity: (!formData.codigo || !formData.modelo) ? 0.5 : 1, cursor: (!formData.codigo || !formData.modelo) ? 'not-allowed' : 'pointer' }}
              >
                2. Asignación Inicial
              </button>
            </div>

            <form onSubmit={handleSave} className="crud-form">
              <div className="modal-scroll-area">
                {regTab === 'tecnica' && (
                  <div className="tab-pane">
                    {apiError && <div style={{ color: 'red', textAlign: 'center', marginBottom: '10px' }}>{apiError}</div>}
                    <div className="form-row">
                      <div className="premium-field">
                        <label>Código de Inventario (Automático)</label>
                        <input
                          required
                          name="codigo"
                          value={formData.codigo}
                          onChange={handleFormChange}
                          placeholder="Ej: EQ-12345"
                        />
                      </div>
                      <div className="premium-field">
                        <label>Modelo / Nombre del Bien</label>
                        <input required name="modelo" value={formData.modelo} onChange={handleFormChange} placeholder="Ej: Dell Optiplex..." />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="premium-field">
                        <label>Categoría</label>
                        <select name="categoria" value={formData.categoria} onChange={handleFormChange}>
                          <option value="PC">PC (Computador de Escritorio)</option>
                          <option value="Notebook">Notebook</option>
                          <option value="Impresora">Impresora / Escáner</option>
                          <option value="Hardware">Hardware / Red</option>
                          <option value="Mobiliario">Mobiliario</option>
                        </select>
                      </div>
                      <div className="premium-field">
                        <label>Estado Inicial</label>
                        <select name="estado" value={formData.estado} onChange={handleFormChange}>
                          <option value="Operativo">Operativo (En uso)</option>
                          <option value="Mantenimiento">Mantenimiento</option>
                          <option value="Baja">Baja (Desecho)</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="input-group full-width">
                        <label>Especificaciones y Detalles</label>
                        <textarea rows="3" name="detalle" value={formData.detalle} onChange={handleFormChange} placeholder="Detalla RAM, Procesador, Marca, Número de serie u otras observaciones..." />
                      </div>
                    </div>
                    <div style={{ textAlign: 'right', marginTop: '10px' }}>
                      <button
                        type="button"
                        className="premium-btn primary"
                        onClick={handleNextStep}
                        disabled={!formData.codigo || !formData.modelo}
                        style={{ opacity: (!formData.codigo || !formData.modelo) ? 0.6 : 1 }}
                      >
                        Continuar a Asignación
                      </button>
                    </div>
                  </div>
                )}

                {regTab === 'asignacion' && (
                  <div className="tab-pane">
                    <div className="info-details-box" style={{ background: '#e7f1ff', borderLeft: '4px solid #0d6efd', marginBottom: '20px', padding: '15px', borderRadius: '4px' }}>
                      <p style={{ margin: 0, fontSize: '13px', color: '#084298' }}>Si dejas el custodio en blanco, el equipo se registrará como <strong>"En Bodega"</strong> sin generar acta inicial.</p>
                    </div>
                    <div className="form-row">
                      <div className="input-group full-width">
                        <label>Funcionario Custodio (Opcional)</label>
                        <select name="custodio" value={formData.custodio} onChange={handleFormChange}>
                          <option value="">-- Sin asignar / En bodega municipal --</option>
                          {funcionariosList.map(f => (
                            <option key={f.id} value={f.id}>{f.nombre}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {formData.custodio && (
                      <div style={{ border: '1px solid #ffeeba', background: '#fff9e6', padding: '15px', borderRadius: '8px', marginTop: '10px' }}>
                        <label style={{ color: '#856404', fontWeight: 'bold', fontSize: '11px', display: 'block', marginBottom: '10px' }}>PARAMETRIZACIÓN DE ACTA INICIAL:</label>
                        <div className="form-row">
                          <div className="premium-field">
                            <label>Folio / Referencia</label>
                            <input
                              type="text"
                              value={referenciaActa}
                              onChange={(e) => setReferenciaActa(e.target.value)}
                              placeholder="Ej: Entrega Bienes"
                            />
                          </div>
                          <div className="premium-field">
                            <label>Tipo de Documento</label>
                            <select value={autoActaType} onChange={e => setAutoActaType(e.target.value)}>
                              <option value="recepcion">Acta de Recepción</option>
                              <option value="traslado">Acta de Traslado</option>
                              <option value="prestamo">Acta de Préstamo</option>
                            </select>
                          </div>
                        </div>
                        {autoActaType === 'prestamo' && (
                          <div className="input-group full-width" style={{ marginTop: '15px' }}>
                            <label style={{ fontWeight: 'bold', color: '#856404' }}>FECHA DE DEVOLUCIÓN REQUERIDA (Opcional):</label>
                            <input
                              type="date"
                              value={fechaDevolucion}
                              onChange={(e) => setFechaDevolucion(e.target.value)}
                              style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ffc107', width: '100%' }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                    <p style={{ fontSize: '11px', color: '#6c757d', marginTop: '15px' }}>Al guardar, se registrará el alta del bien y se abrirá el panel de firma si hay un custodio asignado.</p>
                  </div>
                )}
              </div>

              <div className="modal-footer-actions">
                <button type="button" className="premium-btn secondary" onClick={handleCloseModal}>Cancelar</button>
                {regTab === 'asignacion' && (
                  <button type="submit" className="premium-btn primary">Finalizar y Registrar</button>
                )}
              </div>
            </form>
          </div>
        </div>
      )}

      {detailModalOpen && selectedEquipo && (
        <div className="modal-overlay">
          <div className="modal-content premium-modal x-large">
            <div className="modal-header">
              <h3>{selectedEquipo.modelo} ({selectedEquipo.codigo})</h3>
              <button className="close-modal-btn" onClick={() => setDetailModalOpen(false)}>&times;</button>
            </div>

            <div className="detail-body">
              <div className="modal-tabs">
                <button className={`tab-btn ${activeTab === 'general' ? 'active' : ''}`} onClick={() => setActiveTab('general')}>Especificaciones</button>
                <button className={`tab-btn ${activeTab === 'responsabilidad' ? 'active' : ''}`} onClick={() => setActiveTab('responsabilidad')}>Custodia</button>
                <button className={`tab-btn ${activeTab === 'historial' ? 'active' : ''}`} onClick={() => setActiveTab('historial')}>Historial</button>
                <button className={`tab-btn ${activeTab === 'actas' ? 'active' : ''}`} onClick={() => setActiveTab('actas')}>Actas</button>
                <button className={`tab-btn ${activeTab === 'identificacion' ? 'active' : ''}`} onClick={() => setActiveTab('identificacion')}>QR</button>
              </div>

              <div className="modal-scroll-area">
                {activeTab === 'general' && (
                  <div className="tab-pane">
                    <div className="detail-info-grid">
                      <div className="info-box"><strong>Modelo / Nombre</strong>{selectedEquipo.modelo}</div>
                      <div className="info-box"><strong>Categoría</strong>{selectedEquipo.categoria || 'N/A'}</div>
                      <div className="info-box">
                        <strong>Estado de Operación</strong>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-start', marginTop: '10px' }}>
                          <span className={`badge status-${(selectedEquipo.estado || 'baja').toLowerCase().replace(' ', '-')}`}>{selectedEquipo.estado}</span>
                          <select className="status-selector-minimal" value={selectedEquipo.estado} onChange={(e) => handleChangeStatus(selectedEquipo.id, e.target.value)} style={{ width: '100%' }}>
                            <option value="Operativo">Operativo</option>
                            <option value="Mantenimiento">Mantenimiento</option>
                            <option value="Baja">Baja</option>
                          </select>
                        </div>
                      </div>
                      <div className="info-box"><strong>ID de Inventario</strong>{selectedEquipo.codigo}</div>
                    </div>
                    <div className="info-details-box">
                      <strong>Detalles Técnicos / Observaciones Iniciales (Alta)</strong>
                      <p>{selectedEquipo.detalle || 'Sin observaciones registradas al momento del ingreso.'}</p>
                    </div>

                  </div>
                )}

                {activeTab === 'responsabilidad' && (
                  <div className="tab-pane">
                    <div className="info-details-box" style={{ background: '#f8f9fa', borderLeft: '4px solid #0d6efd', marginBottom: '25px', padding: '15px', borderRadius: '4px' }}>
                      <strong style={{ fontSize: '11px', textTransform: 'uppercase', color: '#495057' }}>Custodio Actual</strong>
                      <p style={{ fontStyle: 'normal', fontWeight: 'bold', fontSize: '16px', color: '#212529', margin: '5px 0' }}>{selectedEquipo.custodio_nombre || 'SISTEMA (EN BODEGA)'}</p>
                      <p style={{ margin: 0, fontSize: '12px', color: '#6c757d' }}>{selectedEquipo.custodio_rut || 'RUT N/A'} • {selectedEquipo.custodio_cargo || 'Cargo N/A'}</p>
                    </div>

                    <div className="crud-form" style={{ border: '1px solid #dee2e6', padding: '20px', borderRadius: '8px' }}>
                      <h3 style={{ fontSize: '15px', marginTop: 0 }}>Asignar Nueva Custodia</h3>
                      <div className="form-row">
                        <div className="premium-field">
                          <label>Funcionario Destino</label>
                          <select value={nuevoCustodio} onChange={e => setNuevoCustodio(e.target.value)}>
                            <option value="">-- Devolver a Bodega --</option>
                            {funcionariosList.map(f => (
                              <option key={f.id} value={f.id}>{f.nombre}</option>
                            ))}
                          </select>
                        </div>
                        <div className="premium-field">
                          <label>Referencia / Nota</label>
                          <input type="text" value={notaTransferencia} onChange={e => setNotaTransferencia(e.target.value)} placeholder="Ej: Cambio de oficina..." />
                        </div>
                      </div>
                      {nuevoCustodio && (
                        <div className="form-row" style={{ background: '#fff9e6', padding: '15px', borderRadius: '6px', border: '1px solid #ffeeba' }}>
                          <div className="premium-field">
                            <label>Configuración de Acta</label>
                            <div style={{ display: 'flex', gap: '10px' }}>
                              <input type="text" value={referenciaActa} onChange={e => setReferenciaActa(e.target.value)} placeholder="Folio/Referencia" />
                              <select value={autoActaType} onChange={e => setAutoActaType(e.target.value)}>
                                <option value="recepcion">Recepción</option>
                                <option value="traslado">Traslado</option>
                                <option value="prestamo">Préstamo</option>
                              </select>
                            </div>
                          </div>
                          {autoActaType === 'prestamo' && (
                            <div className="input-group full-width" style={{ marginTop: '15px' }}>
                              <label style={{ fontWeight: 'bold', color: '#0d6efd' }}>FECHA DE DEVOLUCIÓN REQUERIDA:</label>
                              <input
                                type="date"
                                value={fechaDevolucion}
                                onChange={e => setFechaDevolucion(e.target.value)}
                                required={autoActaType === 'prestamo'}
                                style={{ padding: '10px', borderRadius: '5px', border: '1px solid #0d6efd' }}
                              />
                            </div>
                          )}
                        </div>
                      )}
                      <button className="premium-btn primary" style={{ width: '100%', marginTop: '10px' }} onClick={handleTransferCustodio} disabled={isTransferring}>
                        {isTransferring ? 'Guardando...' : 'Confirmar Transferencia y Generar Acta'}
                      </button>
                    </div>
                  </div>
                )}

                {activeTab === 'historial' && (
                  <div className="tab-pane">
                    <h3 style={{ fontSize: '15px', marginBottom: '15px' }}>Historial de vida</h3>
                    <ul className="historial-list">
                      {isHistorialLoading ? (
                        <li style={{ textAlign: 'center', border: 'none' }}>Obteniendo historial...</li>
                      ) : historial.length > 0 ? (
                        historial.map(h => (
                          <li key={h.id}>
                            <span className="historial-date">{h.fecha} | por {h.usuario_uid}</span>
                            <span className="historial-action">{h.detalle}</span>
                          </li>
                        ))
                      ) : (
                        <li className="empty-history">Sin movimientos registrados.</li>
                      )}
                    </ul>
                  </div>
                )}

                {activeTab === 'actas' && (
                  <div className="tab-pane">
                    <h3 style={{ fontSize: '15px', marginBottom: '15px' }}>Documentos de Control</h3>
                    {actasArchivadas.length > 0 ? (
                      <div className="table-responsive" style={{ maxHeight: '300px' }}>
                        <table className="data-table" style={{ fontSize: '12px' }}>
                          <thead>
                            <tr>
                              <th>Folio</th>
                              <th>Tipo</th>
                              <th>Fecha</th>
                              <th>Acción</th>
                            </tr>
                          </thead>
                          <tbody>
                            {actasArchivadas.map(acta => (
                              <tr key={acta.id}>
                                <td><strong>#{String(acta.correlativo).padStart(4, '0')}</strong></td>
                                <td>{acta.tipo.toUpperCase()}</td>
                                <td>{new Date(acta.fecha).toLocaleDateString()}</td>
                                <td>
                                  <button className="action-btn edit-btn" onClick={() => {
                                    const extra = acta.data_json ? JSON.parse(acta.data_json) : null;
                                    handleGenerateActa(acta.tipo, selectedEquipo, extra, acta.correlativo);
                                  }}>
                                    Ver Copia
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="empty-history" style={{ padding: '40px' }}>No hay actas guardadas para este equipo.</div>
                    )}
                  </div>
                )}

                {activeTab === 'identificacion' && (
                  <div className="tab-pane">
                    <div style={{ background: 'white', padding: '30px', borderRadius: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>
                      <h3 style={{ fontSize: '15px', marginBottom: '20px' }}>Folio de Inventario Digital</h3>
                      <div style={{ display: 'inline-block', padding: '15px', border: '1px solid #dee2e6', borderRadius: '8px', background: '#f8f9fa' }}>
                        <QRCodeCanvas
                          id="qr-gen"
                          value={`${window.location.origin}/equipo/${selectedEquipo.codigo}`}
                          size={160}
                          level={"H"}
                          includeMargin={true}
                        />
                      </div>
                      <div style={{ marginTop: '25px', display: 'flex', gap: '15px', justifyContent: 'center' }}>
                        <button className="premium-btn secondary" onClick={downloadQR}>Descargar PNG</button>
                        <button className="premium-btn primary" onClick={handlePrintQR}>Imprimir Etiqueta</button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="form-footer">
                <button type="button" className="premium-btn secondary" onClick={() => setDetailModalOpen(false)}>Finalizar Consulta</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showPrintPrepModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '600px', padding: '25px' }}>
            <div className="modal-header">
              <h2 style={{ color: '#856404' }}>Preparación de Acta Municipal</h2>
              <button className="close-btn" onClick={() => setShowPrintPrepModal(false)}>×</button>
            </div>

            <div className="prep-form" style={{ marginTop: '15px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div style={{ gridColumn: 'span 2' }}>
                <div className="input-group full-width">
                  <label style={{ fontWeight: 'bold' }}>ESTADO GENERAL:</label>
                  <select
                    value={prepData.estadoGeneral}
                    onChange={e => setPrepData({ ...prepData, estadoGeneral: e.target.value })}
                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
                  >
                    <option value="CONFORME">CONFORME (Excelente estado)</option>
                    <option value="CONFORME CON OBSERVACIONES">CONFORME CON OBSERVACIONES (Desgaste menor)</option>
                    <option value="INCONFORME">INCONFORME (Presenta fallas)</option>
                  </select>
                </div>

                <div className="input-group full-width" style={{ marginTop: '15px' }}>
                  <label style={{ fontWeight: 'bold' }}>OBSERVACIONES ADICIONALES (Se verán en el acta):</label>
                  <textarea
                    rows="2"
                    value={prepData.observaciones}
                    onChange={e => setPrepData({ ...prepData, observaciones: e.target.value })}
                    placeholder="Detalla cualquier ralla, falta de cables o condición especial..."
                    style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
                  />
                </div>
              </div>

              <div style={{ marginTop: '5px', gridColumn: prepData.actaType === 'ingreso_bodega' ? 'span 2' : 'span 1' }}>
                <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px', fontSize: '13px' }}>FIRMA RESPONSABLE INVENTARIO:</label>
                <div style={{ border: '2px dashed #6c757d', borderRadius: '8px', background: '#f8f9fa', overflow: 'hidden' }}>
                  <SignatureCanvas
                    ref={sigPadEncargado}
                    penColor='black'
                    canvasProps={{ width: prepData.actaType === 'ingreso_bodega' ? 550 : 260, height: 140, className: 'sigCanvas' }}
                  />
                </div>
                <div style={{ textAlign: 'right', marginTop: '5px' }}>
                  <button onClick={() => sigPadEncargado.current.clear()} className="premium-btn secondary" style={{ padding: '3px 8px', fontSize: '10px' }}>Borrar</button>
                </div>
              </div>

              {prepData.actaType !== 'ingreso_bodega' && (
                <div style={{ marginTop: '5px' }}>
                  <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px', fontSize: '13px' }}>FIRMA FUNCIONARIO (CUSTODIO):</label>
                  <div style={{ border: '2px dashed #0d6efd', borderRadius: '8px', background: '#f8f9ff', overflow: 'hidden' }}>
                    <SignatureCanvas
                      ref={sigPadCustodio}
                      penColor='black'
                      canvasProps={{ width: 260, height: 140, className: 'sigCanvas' }}
                    />
                  </div>
                  <div style={{ textAlign: 'right', marginTop: '5px' }}>
                    <button onClick={() => sigPadCustodio.current.clear()} className="premium-btn secondary" style={{ padding: '3px 8px', fontSize: '10px' }}>Borrar</button>
                  </div>
                </div>
              )}
            </div>

            <div className="form-footer" style={{ marginTop: '25px' }}>
              <button type="button" className="premium-btn secondary" onClick={() => setShowPrintPrepModal(false)}>Cancelar</button>
              <button
                type="button"
                className="premium-btn primary"
                style={{ background: '#20c997', border: 'none' }}
                onClick={async () => {
                  const isIngresoBodega = prepData.actaType === 'ingreso_bodega';
                  if (sigPadEncargado.current.isEmpty()) return alert('La firma del Responsable de Inventario es obligatoria.');
                  if (!isIngresoBodega && sigPadCustodio.current.isEmpty()) return alert('La firma del Funcionario es obligatoria para este tipo de acta.');

                  let signatureImgEncargado;
                  let signatureImgCustodio;
                  try {
                    signatureImgEncargado = sigPadEncargado.current.getTrimmedCanvas().toDataURL('image/png');
                    signatureImgCustodio = isIngresoBodega ? null : sigPadCustodio.current.getTrimmedCanvas().toDataURL('image/png');
                  } catch (e) {
                    signatureImgEncargado = sigPadEncargado.current.getCanvas().toDataURL('image/png');
                    signatureImgCustodio = isIngresoBodega ? null : sigPadCustodio.current.getCanvas().toDataURL('image/png');
                  }

                  let finalEquipoToPrint = prepData.equipoToPrint;
                  try {
                    if (prepData.pendingAction === 'transfer') {
                      const resp = await fetch(`${apiBase}/api/equipos/${prepData.equipoToPrint.id}/custodio`, {
                        method: 'PATCH',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(prepData.pendingPayload)
                      });
                      if (!resp.ok) throw new Error('Error al transferir equipo');

                      const freshListResp = await fetch(`${apiBase}/api/equipos`);
                      const freshDataList = await freshListResp.json();
                      finalEquipoToPrint = freshDataList.find(e => e.id === prepData.equipoToPrint.id);
                    } else if (prepData.pendingAction === 'status_mantenimiento') {
                      const resp = await fetch(`${apiBase}/api/equipos/${prepData.equipoToPrint.id}/estado`, {
                        method: 'PATCH',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          nuevoEstado: 'Mantenimiento',
                          usuario: JSON.parse(localStorage.getItem('user') || '{}').nombre || 'Sistema'
                        })
                      });
                      if (!resp.ok) throw new Error('Error al cambiar a mantenimiento');

                      const freshListResp = await fetch(`${apiBase}/api/equipos`);
                      const freshDataList = await freshListResp.json();
                      finalEquipoToPrint = freshDataList.find(e => e.id === prepData.equipoToPrint.id);
                    }
                  } catch (err) {
                    alert('Hubo un error al guardar los datos en el servidor. El acta no se generará.');
                    console.error(err);
                    return;
                  }

                  const finalDataForActa = { ...prepData, signatureCustodio: signatureImgCustodio, signatureEncargado: signatureImgEncargado };
                  setShowPrintPrepModal(false);
                  const equipoUsedForActa = prepData.actaType === 'devolucion' ? prepData.equipoToPrint : finalEquipoToPrint;
                  await handleGenerateActa(prepData.actaType, equipoUsedForActa, finalDataForActa);

                  fetchEquipos();

                  if (finalEquipoToPrint) {
                    fetch(`${apiBase}/api/equipos/${finalEquipoToPrint.id}/historial`)
                      .then(h => h.json())
                      .then(setHistorial)
                      .catch(console.error);
                  }

                  if (prepData.pendingAction === 'transfer') {
                    setNotaTransferencia('');
                  }
                  if (prepData.pendingAction === 'create') {
                    setFormData({ codigo: '', modelo: '', categoria: 'PC', estado: 'Operativo', custodio: '', detalle: '' });
                  }
                }}
              >
                Finalizar Documento e Imprimir
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
